<template>
  <v-card>
    <v-card-title class="cardtitle mb-2 rounded-0">Other Possible Death Reasons</v-card-title>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-select
          v-model="newData.suspectedCause"
          label="Suspected cause"
          :items="OtherSuspectedCause"
        />
        <v-text-field
          v-model="newData.extraDetails"
          label="Extra details"
        />
        <v-text-field
          v-model="newData.samplesForAnalysisRabies"
          label="If rabies applicable, sample sent for analysis?"
        />
        <v-text-field
          v-model="newData.rabiesLab"
          label="Rabies lab"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="error"
        @click="cancel"
      >Cancel</v-btn>
      <v-btn
        color="grey lighten-2"
        @click="reset"
      >Clear</v-btn>
      <v-btn
        :disabled="!valid || !isDirty"
        color="#7eb09f"
        @click="validate"
      >Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import OtherPossibleDeathReasons from '@/models/otherpossibledeathreasons.js'
import { OtherSuspectedCause } from '@/utils/selectoptions.js'

export default {
  props: {
    OtherPossibleDeathReasons: {
      type: Object,
      default: function () {
        return {}
      }
    },
    passed: {
      type: Boolean,
      default: false
    },
    entrycode: {
      type: Number
    }
  },
  data: function () {
    return {
      valid: false,
      loading: false,
      required: [
        v => !!v || 'Field is required'
      ],
      OtherSuspectedCause: OtherSuspectedCause
    };
  },
  methods: {
    validate () {
      this.loading = true
      if (this.$refs.form.validate()) {
        this.$store.dispatch('incidentsnew/updOtherreasons', {entrycode: this.entrycode, payload: this.newData})
          .then(() => {
            this.loading = false
            this.initData = {...this.newData}
          })
          .catch(e => {
            console.log('WE GOT THE ERROR')
            console.log(this.$store.state.incidentsnew.error)
          })  // FIXME
      } else {
        this.loading = false
      }
    },
    cancel () {
      this.$router.back();
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
  },
  created () {
    this.newData = new OtherPossibleDeathReasons()
  },
  mounted () {
    if (this.passed) {
      this.initData = {...this.OtherPossibleDeathReasons}
      this.newData = this.OtherPossibleDeathReasons
      this.$refs.form.resetValidation()
    }
  },
  computed: {
    ...sync('form', [
      'initData',
      'newData'
    ]),
    ...get('form', [
      'isDirty'
    ])
  }
};
</script>

<style scoped>
.cardtitle {
  background-color: #7eb09f;
}
</style>